import { render, staticRenderFns } from "./VirtualVisitPopup.vue?vue&type=template&id=54b4b870&scoped=true&"
import script from "./VirtualVisitPopup.vue?vue&type=script&lang=js&"
export * from "./VirtualVisitPopup.vue?vue&type=script&lang=js&"
import style0 from "./VirtualVisitPopup.vue?vue&type=style&index=0&id=54b4b870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4b870",
  null
  
)

export default component.exports